import { render } from "./RedirectView.vue?vue&type=template&id=30da21a2"
import script from "./RedirectView.vue?vue&type=script&lang=js"
export * from "./RedirectView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SebastiánContreras\\OneDrive - Defensoría del Contribuyente\\Documents\\INGENIERIA DESARROLLO_TI\\REPOSITORIO_PROYECTOS\\AUTENTIFICACION_FRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__